import { useMemo } from 'react';

import { getUserFullName } from '@/services/helpers/strings';
import { useAppSelector } from '@/store';

import { type HistoryDataSourceInterface } from '../table-data-source';

const useIeLeasingHistory = () => {
  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const ieLeasingData: HistoryDataSourceInterface[] = useMemo(() => {
    if (!request) return [];

    return request.history.map((item) => ({
      comment: [item.action, item.comment].filter(Boolean).join(' | '),
      date: item.createDate,
      id: `${item.action}_${item.createDate}`,
      initiator: getUserFullName(item.user)
    }));
  }, [request]);

  return {
    ieLeasingData,
    totalIeLeasingData: ieLeasingData.length
  };
};

export default useIeLeasingHistory;
